import { FC } from 'react'
import { TruncatedTooltip } from 'src/components/TruncatedTooltip'
import { TopicEntry, barFillRatio } from 'src/interfaces/topics.interface'
import styles from './topicRow.module.scss'
import { DeltaBadge } from '../DeltaBadge'
import { SentimentBar } from '../SentimentBar'

interface TopicRowProps {
  entry: TopicEntry
  // The largest mention count on show, so every bar is read against the leader.
  max: number
  rank: number
}

export const TopicRow: FC<TopicRowProps> = ({ entry, max, rank }) => (
  <div className={styles.row}>
    <div className={styles.header}>
      <span className={styles.rank}>#{rank}</span>
      {/* min-width:0 lives on the wrapper in SCSS — without it a long,
          space-less name refuses to shrink and pushes the figures out. */}
      <TruncatedTooltip className={styles.name} text={entry.name} />
      <span className={styles.meta}>
        {entry.mentions.toLocaleString()} ({entry.share}%)
      </span>
      <DeltaBadge value={entry.delta} />
    </div>
    <SentimentBar
      fill={barFillRatio(entry.mentions, max)}
      sentiment={entry.sentiment}
    />
  </div>
)
